<template>
	<div class="mb-2">
		<v-form
			class="d-flex justify-space-between align-start"
			@submit.prevent="$emit('search', filteredData)"
		>
			<div
				class="search-row"
				align="center"
				dense
			>
				<div
					class="search-col"
					:style="`${item.type === 'switch_date' && '--search-width: 250px'}`"
					v-for="(item, i) in filteredBones"
					:key="i"
				>
					<!-- name or code -->
					<v-text-field
						v-if="item.type === 'name'"
						v-model="data[item.value]"
						dense
						outlined
						:label="item.placeholder || $T('inputs.search-by-name-or-code')"
						hide-details></v-text-field>
					<!-- section -->
					<v-autocomplete
						v-if="item.type === 'section'"
						v-model="data[item.value]"
						:items="sections"
						:disabled="!sections.length"
						item-text="name"
						item-value="id"
						clearable
						dense
						outlined
						:label="item.placeholder || $T('inputs.search-by-section')"
						hide-details>
					</v-autocomplete>

					<!-- penalties -->
					<v-autocomplete
						v-if="item.type === 'penalties'"
						v-model="data[item.value]"
						:items="penalties"
						:loading="!penalties.length"
						:disabled="!penalties.length"
						item-text="name"
						item-value="id"
						clearable
						dense
						outlined
						:label="item.placeholder || $T('inputs.search-by-section')"
						hide-details>
					</v-autocomplete>

					<!-- rewards -->
					<v-autocomplete
						v-if="item.type === 'rewards'"
						v-model="data[item.value]"
						:items="rewards"
						:loading="!rewards.length"
						:disabled="!rewards.length"
						item-text="name"
						item-value="id"
						clearable
						dense
						outlined
						:label="item.placeholder || $T('inputs.search-by-section')"
						hide-details
					></v-autocomplete>
			
					<!-- position -->
					<v-autocomplete
						v-if="item.type === 'position'"
						v-model="data[item.value]"
						:items="positions"
						:disabled="!positions.length"
						item-text="name"
						item-value="id"
						clearable
						dense
						outlined
						:label="item.placeholder || $T('inputs.employee-position')"
						hide-details></v-autocomplete>

					<!-- leave -->
					<v-autocomplete
						v-if="item.type === 'leaveType'"
						v-model="data[item.value]"
						:items="leaveType.filter(c => c.type === 0)"
						:disabled="!leaveType.filter(c => c.type === 0).length"
						item-text="name"
						item-value="id"
						clearable
						dense
						outlined
						:label="item.placeholder || $T('inputs.employee-leave')"
						hide-details></v-autocomplete>

					<!-- permissions -->
					<v-autocomplete
						v-if="item.type === 'permissionsType'"
						:disabled="!permissionsType.filter(c => c.type === 1).length"
						v-model="data[item.value]"
						:items="permissionsType.filter(c => c.type === 1)"
						item-text="name"
						item-value="id"
						clearable
						dense
						outlined
						:label="item.placeholder || $T('inputs.employee-permission')"
						hide-details>
					</v-autocomplete>

					<!-- tasksType -->
					<v-autocomplete
						v-if="item.type === 'tasksType'"
						v-model="data[item.value]"
						:items="tasksType"
						:disabled="!tasksType.length"
						item-text="name"
						item-value="id"
						clearable
						dense
						outlined
						label="نوع المهمة"
						hide-details></v-autocomplete>
					<!-- from date -->
					<bee-date-input
						v-if="item.type === 'from_date'"
						v-model="data[item.value]"
						:label="item.placeholder || $T('from')"
						class="styled"
						dense
						fit-inputs
						hide-details
						changeable-with-arrows
						changeable-on-scroll
						prepend-icon="$calendar"
						user-menu-picker></bee-date-input>
					<!-- to date -->
					<bee-date-input
						v-if="item.type === 'to_date'"
						:disabled="
							filteredBones.map((e) => e.type).includes('from_date') && !data['DateFrom']
						"
						v-model="data[item.value]"
						:label="item.placeholder || $T('to')"
						class="styled"
						dense
						fit-inputs
						hide-details
						changeable-with-arrows
						changeable-on-scroll
						prepend-icon="$calendar"
						user-menu-picker></bee-date-input>
					<!-- switch date -->
					<div
						v-if="item.type === 'switch_date'"
						class="d-flex align-center">
						<v-btn
							@click="prevDate(item.value)"
							icon>
							<v-icon>mdi-arrow-right-bold</v-icon>
						</v-btn>
						<bee-date-picker
							key="month"
							v-model="data[item.value]"
							:input-label="item.placeholder || $T('inputs.date')"
							:input-props="{ outlined: true, dense: true, prependInnerIcon: '$calendar' }"
							menu-picker
							calendar
							no-title
							hide-details></bee-date-picker>
						<v-btn
							@click="nextDate(item.value)"
							icon>
							<v-icon>mdi-arrow-left-bold</v-icon>
						</v-btn>
					</div>

					<v-btn-toggle
						mandatory
						v-if="item.type === 'toggle'"
						v-model="data[item.value]"
						dense>
						<v-btn
							small
							:value="btn.for"
							v-for="(btn, i) in item.items"
							:key="i">
							{{ btn.name }}
						</v-btn>
					</v-btn-toggle>
				</div>

				<div
					class="search-col"
					cols="auto">
					<v-btn
						:disabled="!showClearBtn"
						class="me-1"
						outlined
						small
						color="primary"
						type="submit">
						<v-icon
							small
							left>
							mdi-magnify
						</v-icon>
						{{ $T('default-buttons.search') }}
					</v-btn>
					<v-btn
						v-if="showClearBtn"
						style="min-width: 30px"
						class="px-0"
						outlined
						small
						color="alert"
						@click="clearFilters">
						<v-icon small> $clear </v-icon>
					</v-btn>
				</div>
				<slot></slot>
			</div>
			<v-spacer></v-spacer>

			<v-divider
				v-if="addName || this.$scopedSlots.end"
				vertical
				class="mx-1"></v-divider>

			<v-btn
				v-if="addName"
				@click="$emit('add')"
				color="primary"
				small
			>
				<v-icon
					size="20"
					left>
					$add
				</v-icon>
				{{ addName }}
			</v-btn>
			<slot name="end"></slot>
		</v-form>
	</div>
</template>

<script>
import { mapState } from 'vuex';
import moment, { DATE_FORMAT } from '@/utils/moment';
import { nextTick, set } from 'vue';

export default {
	props: {
		value: { type: Object },

		addName: {
			type: String,
		},

		// name - section - position - from_date - to_date - toggle - switch_date
		bones: { type: Array, default: () => [] },
	},

	data() {
		return {
			data: {},
		};
	},

	watch: {
		data: {
			handler() {
				this.$emit('input', this.filteredData);
			},
			deep: true,
		},
	},

	computed: {
		filteredBones() {
			return this.bones.filter((b) => {
				if (b.toggle) {
					const toggle = this.bones.find((e) => b.toggle === e.value);
					return this.data[toggle.value]?.includes(b.value);
				}
				return true;
			});
		},
		filteredData() {
			const obj = {};
			this.filteredBones.forEach((e) => {
				if (e.type === 'switch_date' && e.valuesAs) {
					obj[e.valuesAs[0]] = this.data[e.value];
					obj[e.valuesAs[1]] = this.data[e.value];
					// obj[e.valuesAs[1]] = moment(this.data[e.value]).add(1, 'd').format(DATE_FORMAT);
				} else {
					obj[e.value] = this.data[e.value];
				}
			});
			return obj;
		},
		showClearBtn() {
			return true;
			// return Object.values(this.data).reduce(
			// 	(p, c) => Boolean(p || (Array.isArray(c) ? false : c)),
			// 	false,
			// );
		},
		...mapState({
			sections: (state) => state.section.sections,
			positions: (state) => state.positions.positions,
			penalties: state => state.penaltiesRewards.penalties,
			rewards: state => state.penaltiesRewards.rewards,
			leaveType: state => state.leaveOrPermission.leaves,
			permissionsType: state => state.leaveOrPermission.permissions,
			tasksType: state => state.addTaskType.tasksType
		}),
	},

	methods: {
		justClear() {
			Object.keys(this.data).forEach((e) => (this.data[e] = null));
		},
		clearFilters() {
			Object.keys(this.data).forEach((e) => (this.data[e] = null));

			nextTick(() => {
				this.$emit('clear');
			});
		},

		nextDate(key) {
			this.data[key] = (this.data[key] ? moment(this.data[key]) : moment())
				.add(1, 'd')
				.format('YYYY-MM-DD');
			nextTick(() => {
				this.$emit('search', this.filteredData);
			});
		},
		prevDate(key) {
			this.data[key] = (this.data[key] ? moment(this.data[key]) : moment())
				.subtract(1, 'd')
				.format('YYYY-MM-DD');
			nextTick(() => {
				this.$emit('search', this.filteredData);
			});
		},
	},

	created() {
		this.bones.forEach((bone) => {
			let value;
			switch (bone.type) {
				case 'from_date':
					value = moment().startOf('month').format(DATE_FORMAT);
					break;
				case 'to_date':
					value = moment().endOf('month').format(DATE_FORMAT);
					break;
				case 'switch_date':
					value = moment().format(DATE_FORMAT);
					break;
				case 'toggle':
					value = [...bone.items[0].for];
					break;

				default:
					break;
			}
			set(this.data, bone.value, value);
		});
		this.$emit('input', this.filteredData);
	},
};
</script>

<style lang="scss" scoped>
.search-row {
	margin: -4px;
	margin-bottom: 4px;
	display: flex;
	flex-wrap: wrap;
	align-items: center;
}
.search-col {
	padding: 4px;
	max-width: var(--search-width, 200px);
}
</style>
